define( function() {
	"use strict";

	return [ "Top", "Right", "Bottom", "Left" ];
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/css/var/cssExpand.js
// module id = 64
// module chunks = 0